import request from '@/axios'
export function fetch_user_list (customerId, from_user_type) {
  return request({
    url:`/chat/fetch_user_list/${customerId}/${from_user_type}`,
    method: 'GET'
  })
}

export function fetch_user_general_list (from_user_type, customerId) {
  return request({
    url:`/users/fetch_user_list/${from_user_type}/${customerId}`,
    method: 'POST'
  })
}

export function sendSaveEmail (customerId, emailPayload) {
  return request({
    url:`V1/communication/email/send/${customerId}`,
    method: 'POST',
    data: emailPayload
  })
}

export function getEmailInboxList (sorting_obj, table_name, payload, customerId, page,  limit) {
  return request({
    url:`V1/communication/email/list/INBOX/${customerId}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`,
    method: 'POST',
    data:payload
  })
}

export function getEmailSentList (sorting_obj, table_name, payload, customerId, page, limit) {
  let url = `/V1/communication/email/list/SENT/${customerId}?table_name=${table_name}&page=${page}&limit=${limit}`
  if (Object.entries(sorting_obj).length > 0) {
    url = `V1/communication/email/list/SENT/${customerId}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`
  }
  return request({
    url,
    method: 'POST',
    data:payload
  })
}

export function getEmailDraftList (sorting_obj, table_name, payload, customerId, page, limit) {
  return request({
    url:`V1/communication/email/list/DRAFT/${customerId}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`,
    method: 'POST',
    data:payload
  })
}


export function deleteInboxEmail (customerId, email_ids) {
  return request({
    url:`/communication/email/delete/INBOX/${customerId}`,
    method: 'POST',
    data: email_ids
  })
}
  
export function deleteSentEmail (customerId, email_ids) {
  return request({
    url:`/communication/email/delete/SENT/${customerId} `,
    method: 'POST',
    data: email_ids
  })
}
  
export function deleteDraftEmail (customerId, email_ids) {
  return request({
    url:`/communication/email/delete/DRAFT/${customerId} `,
    method: 'POST',
    data: email_ids
  })
}

export function getSentEmailThread (customer_id, email_id) {
  return request({
    url: `/communication/email/view/SENT/${customer_id}`,
    method: 'POST',
    data: email_id
  })
}

export function getInboxEmailThread (customer_id, email_id) {
  return request({
    url: `/communication/email/view/INBOX/${customer_id}`,
    method: 'POST',
    data: email_id
  })
}

export function getCommunicationSettings (customer_id) {
  return request({
    url: `/communication/setting/${customer_id}`,
    method: 'GET'
  })
}

export function updateCommunicationSettings (customer_id, settings_payload) {
  return request({
    url: `/communication/setting/${customer_id}`,
    method: 'POST',
    data:settings_payload
  })
}

export function sendSMS (customerId, payload) {
  return request({
    url:`/communication/sms/send/${customerId}`,
    method: 'POST',
    data: payload
  })
}

export function deleteSMS (customerId, payload) {
  return request({
    url:`/communication/sms/delete/${customerId}/SENT`,
    method: 'POST',
    data: payload
  })
}

export function fetchSMSLog (customerId, page, limit = 10, payload = {}) {
  return request({
    url:`/communication/sms/list/${customerId}/SENT?page=${page}&limit=${limit}`,
    method: 'POST',
    data: payload
  })
}

export function fetchChatLog (customerId) {
  return request({
    url:`/chat/get_recent_chat/${customerId}`,
    method: 'GET'
  })
}
